// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"4631":"0b49cbf8","5587":"a544d438","8225":"7b9bcd0e","8434":"705ce0fb","9103":"b9ea4917"}[chunkId] + ".css";
};